import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sales-box',
  templateUrl: './sales-box.component.html',
  styleUrls: ['./sales-box.component.scss']
})
export class SalesBoxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
